import useViewport from './useViewport';
import { constants } from '@wsb/guac-widget-core';
const { breakpoints = {} } = constants;

export const devices = {
  MOBILE: 'MOBILE',
  TABLET: 'TABLET',
  DESKTOP: 'DESKTOP'
};

const devicesBreakpoints = {
  [devices.MOBILE]: [0, breakpoints.XS_MAX],
  [devices.TABLET]: [breakpoints.SM_MIN, breakpoints.SM_MAX],
  [devices.DESKTOP]: [breakpoints.MD_MIN, Number.MAX_SAFE_INTEGER]
};

export function getDeviceFromViewport(width = window.innerWidth) {
  const entry = Object.entries(devicesBreakpoints).find(
    ([_, [min, max]]) => width >= min && width <= max
  );
  return entry?.[0] || devices.DESKTOP;
}

function useDevice() {
  const { width } = useViewport();

  const device = Object.entries(devicesBreakpoints).find(
    ([_, [minWidth, maxWidth]]) => width >= minWidth && width <= maxWidth
  );

  return device;
}

export default useDevice;
